import Model from "@/app/models/Concerns/Model";
import Answer from './Answer';
import Part from "@/app/models/Part";
import ProductType from "@/app/models/ProductType";

export default class Question extends Model {
    station_id!: number;
    product_type_id!: number;
    image_only!: boolean;
    image_required!: boolean;
    no_required!: boolean;
    yes_required!: boolean;
    not_applicable_required!: boolean;
    show_explanation!: boolean;
    is_header_text!: boolean;
    order!: number;
    question!: string;
    subtitle!: string | null;
    answer?: Answer;
    parts!: Part[];
    productTypes!: ProductType[];
    is_scaffoldless_station!: boolean;

    constructor(data: { tabs: any[] } | { [key: string]: any }) {
        super(data);
        this.parts = this.parts || [];
        this.productTypes = this.productTypes || [];
    }

    get casts(): any {
        return {
            parts: (data: any[]) => data.map((pt: any) => new Part(pt)),
            productTypes: (data: any[]) => data.map((pt: any) => new ProductType(pt)),
            answer: (data: any) => {
                if (!data) {
                    return null;
                }
                if (data instanceof Answer) {
                    return data;
                }
                return new Answer(
                    data.value ?? null,
                    data.image ?? null,
                    data.explanation ?? null,
                    data.image_url ?? null,
                );
            },
        };
    }

    getTable(): string {
        return "questions";
    }
}
